import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/P2pEnergyForm";


export function createP2pEnergyRequestApiRequest(data: any): Promise<AxiosResponse> {
    return axiosInstance.post(`${API.URL_CREATE_P2P_ENERGY_FORM_REQUEST}`, data).then((d: AxiosResponse) => d.data);
}
